const SLOW_NETWORK_THRESHOLD_MS = 1000;

type SlowNetworkListener = (visible: boolean) => void;

const listeners = new Set<SlowNetworkListener>();

let hasInitialLoadCompleted = false;
let pendingInitialRequests = 0;
let showOverlay = false;
let initialSlowTimerId: number | null = null;
let hasDefinedInitialData = false;

const notifyListeners = () => {
  const isVisible = !hasInitialLoadCompleted && showOverlay;
  listeners.forEach((listener) => listener(isVisible));
};

export const subscribeSlowNetwork = (listener: SlowNetworkListener) => {
  listeners.add(listener);
  listener(!hasInitialLoadCompleted && showOverlay);
  return () => {
    listeners.delete(listener);
  };
};

export const getSlowNetworkThresholdMs = () => SLOW_NETWORK_THRESHOLD_MS;

export const beginInitialRequest = () => {
  if (hasInitialLoadCompleted) return false;
  pendingInitialRequests += 1;
  if (pendingInitialRequests === 1) {
    initialSlowTimerId = window.setTimeout(() => {
      if (!hasInitialLoadCompleted && pendingInitialRequests > 0) {
        showOverlay = true;
        notifyListeners();
      }
    }, getSlowNetworkThresholdMs());
  }
  return true;
};

export const completeInitialRequest = (hasDefinedData: boolean) => {
  if (hasInitialLoadCompleted) return;
  if (hasDefinedData) {
    hasDefinedInitialData = true;
  }
  pendingInitialRequests = Math.max(0, pendingInitialRequests - 1);
  if (pendingInitialRequests === 0) {
    if (initialSlowTimerId !== null) {
      window.clearTimeout(initialSlowTimerId);
      initialSlowTimerId = null;
    }
    if (hasDefinedInitialData) {
      hasInitialLoadCompleted = true;
      showOverlay = false;
    } else {
      // Initial API batch finished but UI data is still undefined.
      showOverlay = true;
    }
  }
  notifyListeners();
};

export const resetSlowNetworkState = () => {
  hasInitialLoadCompleted = false;
  pendingInitialRequests = 0;
  showOverlay = false;
  hasDefinedInitialData = false;
  if (initialSlowTimerId !== null) {
    window.clearTimeout(initialSlowTimerId);
    initialSlowTimerId = null;
  }
  notifyListeners();
};
